
export const TreeIcon: React.FC = () => (
  <path
    fill="none"
    stroke="#fff8b8"
    strokeWidth={2}
    d="M3.6-43.77c7.53-4.72 15.29-5.34 22.68.11s9 12.89 6.83 21.24a63 63 0 016.62 4.71 18.63 18.63 0 013.51 23A18.6 18.6 0 0121.43 14c-2.51-.81-3.95-.39-5.64 1.49-3.71 4.11-9.22 7.44-11.07 12.24s-.16 11 0 16.51c.08 2.54.24 5.07.38 7.86H-6.33c.35-7.77.58-15.4 1.07-23 .23-3.53-.31-6.43-3-9.09-3.19-3.17-5.92-6.82-8.81-10.22-11 4.93-23 1.49-27.4-10.46-3.92-10.65 1.55-20.21 14.22-25.13-2.77-10.45-.37-19.12 9.77-24.31C-12.56-54.16-5.11-52 3.6-43.77zM3.83 19l10.5-8.57-4.4-5.26a39.24 39.24 0 00-5 2 3.12 3.12 0 00-1.5 2.21c-.07 2.93.2 5.92.4 9.62zm-8.3-11.41c-3.26.25-5.77-2.65-9.65-1l9.26 8.57c.15-2.9.26-4.92.39-7.57z"
  />
);
